// Lib
import React from 'react';
import { LoadingIndicator } from '@milanote/roma';

// Components
import Toast from '../../../../../structural/toast/Toast';
import {
    IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE,
    type ImageModalBackgroundRemovalToastState,
} from './imageModalBackgroundRemovalToastTypes';

// Styles
import './ImageModalBackgroundRemovalToast.scss';

/**
 * Shows background-removal progress inside the image modal toast layer.
 */
const ImageModalBackgroundRemovalToast: React.FC<{
    toast: ImageModalBackgroundRemovalToastState | null;
}> = ({ toast }) => {
    if (!toast) return null;

    const isUploadingImage = toast.message === IMAGE_MODAL_BACKGROUND_REMOVAL_TOAST_MESSAGE.UPLOADING_IMAGE;
    const message = isUploadingImage ? 'Uploading image' : 'Removing background';

    return (
        <Toast className="ImageModalBackgroundRemovalToast" groupId="ImageModalV2">
            <LoadingIndicator size="xs">{message}</LoadingIndicator>
        </Toast>
    );
};

export default ImageModalBackgroundRemovalToast;
